@charset "UTF-8";

/* src/smoothr-web-app-core/components/payment-modal/payment-modal.component.scss */
ion-spinner {
  margin: 32px;
  height: 72px;
  width: 72px;
}
.payment-input {
  margin: 6px 12px;
  border-radius: 5px;
  padding: var(--ion-margin);
  color: var(--ion-color-black);
}
.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  text-transform: uppercase;
}
.header ion-icon {
  width: 25px;
  height: 25px;
}
.header .back-icon {
  width: 20px;
  height: 20px;
}
.header-msg {
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
}
.payment-method-row {
  align-items: center;
  margin: 6px 12px;
  border-radius: 26px;
  border: 1px solid var(--color-black);
  text-transform: uppercase;
}
.payment-method-row > ion-col {
  padding: 0;
}
.payment-method-row > ion-col ion-item {
  overflow: hidden;
  --background: #00000000;
}
.payment-method-row > ion-col ion-item > ion-radio {
  --color: var(--ion-color-primary);
  --color-checked: var(--ion-color-primary);
  margin: 11px 16px 10px 4px;
}
.payment-method-row > ion-col ion-item > ion-label {
  color: var(--ion-color-black);
}
.back-icon {
  margin-right: 10px;
  width: 30px;
}
.bottom-end {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 300px;
  width: 142px;
}
.padding-5 {
  padding: 5px;
}
ion-content {
  --background: #FAF7F6;
}
.icon-size {
  margin: 0px;
  zoom: var(--payment-icon-size);
}
.cash-block {
  display: flex;
  justify-content: center;
}
.cash-block ion-button {
  width: 60%;
  margin: 10px auto;
}
.payment-link {
  width: 100%;
  height: 100%;
  padding: 8px 15px;
  font-size: 16px;
  text-transform: uppercase;
  background: #F48B7F;
  color: white;
  text-decoration: none;
  text-align: center;
  margin-bottom: 30px;
  border-radius: 28px;
}
.payment-link:hover {
  background: #FC5E07;
}
.bottom-separator {
  padding-top: 10px;
}
#customCard-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
#customCard-container label {
  display: flex;
  align-items: center;
  width: 100%;
}
#customCard-container label iframe {
  height: 50px;
}
#customCard-container {
  padding: 20px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 80%;
  margin: 0 auto;
}
#customCard-container ion-spinner {
  margin: 0 auto;
}
#customCard-container .adyen-checkout__field-wrapper {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}
#customCard-container .adyen-checkout__label {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
}
#customCard-container .adyen-checkout__input {
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  background-color: #f9f9f9;
  transition: border-color 0.3s ease-in-out;
}
#customCard-container .adyen-checkout__input:focus {
  border-color: #007bff;
  outline: none;
}
#customCard-container .adyen-checkout__input--error {
  border-color: #ff4d4d;
  background-color: #ffe6e6;
}
#customCard-container .adyen-checkout__error-text {
  color: #ff4d4d;
  font-size: 12px;
  margin-top: 5px;
}
#payButton {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: var(--ion-color-primary);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  margin-top: 10px;
}
#payButton.hidden {
  visibility: hidden;
}
#payButton:hover {
  background-color: #218838;
}
#payButton:active {
  background-color: #1e7e34;
}
#customCard-container .adyen-checkout__card__form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
#customCard-container .adyen-checkout__card__form .adyen-checkout__field-wrapper {
  flex: 1;
  min-width: 48%;
}
.payment-modal-container {
  padding: 20px;
}
.payment-modal-container h2 {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}
.payment-modal-container .payment-method {
  margin-bottom: 20px;
}
.payment-modal-container .total-price {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: right;
}
.iframe-wrapper {
  position: relative;
  display: inline-block;
}
.iframe-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.5);
}
.input_data {
  width: 100%;
}
.added-gift {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px;
  border-bottom: 1px solid var(--color-black);
  border-top: 1px solid var(--color-black);
}
.added-gift .header-gift {
  width: 35px;
  height: 35px;
  min-height: 35px;
  min-width: 35px;
  background: #F48B7F;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.added-gift .inner-text-gift {
  margin-left: 5px;
}
.added-gift .inner-text-gift h3 {
  text-transform: uppercase;
  font-size: 14px;
}
.added-gift .inner-text-gift p {
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .delete-items-section {
  margin-left: auto;
}
.added-gift ion-img {
  width: 45px;
}
.info-section {
  background: var(--ion-color-primary);
  padding: 20px;
  display: flex;
  align-items: center;
}
.info-section ion-icon {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}
.info-section p {
  font-size: 12px;
  color: white;
  text-transform: uppercase;
}
.close-icon {
  margin: 0px;
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
/*# sourceMappingURL=payment-modal.component.css.map */
